var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftEdgeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3511_38129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.775 47.625C56.9168 48.071 56.0317 48.4634 55.125 48.8C52.2539 49.8686 49.2135 50.4107 46.15 50.4C34.325 50.4 24.025 42.275 24.025 31.825C24.0404 30.4257 24.4283 29.0558 25.149 27.8562C25.8696 26.6566 26.8968 25.6707 28.125 25C17.425 25.45 14.675 36.6 14.675 43.125C14.675 61.625 31.7 63.475 35.375 63.475C37.35 63.475 40.325 62.9 42.125 62.325L42.45 62.225C49.3385 59.8444 55.2109 55.1889 59.1 49.025C59.213 48.8377 59.2615 48.6185 59.2381 48.4011C59.2146 48.1836 59.1205 47.9798 58.9701 47.8209C58.8198 47.662 58.6215 47.5568 58.4056 47.5215C58.1897 47.4861 57.9682 47.5224 57.775 47.625V47.625Z",
    fill: "url(#paint0_linear_3511_38129)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.775 47.625C56.9168 48.071 56.0317 48.4634 55.125 48.8C52.2539 49.8686 49.2135 50.4107 46.15 50.4C34.325 50.4 24.025 42.275 24.025 31.825C24.0404 30.4257 24.4283 29.0558 25.149 27.8562C25.8696 26.6566 26.8968 25.6707 28.125 25C17.425 25.45 14.675 36.6 14.675 43.125C14.675 61.625 31.7 63.475 35.375 63.475C37.35 63.475 40.325 62.9 42.125 62.325L42.45 62.225C49.3385 59.8444 55.2109 55.1889 59.1 49.025C59.213 48.8377 59.2615 48.6185 59.2381 48.4011C59.2146 48.1836 59.1205 47.9798 58.9701 47.8209C58.8198 47.662 58.6215 47.5568 58.4056 47.5215C58.1897 47.4861 57.9682 47.5224 57.775 47.625V47.625Z",
    fill: "url(#paint1_radial_3511_38129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.425 60.3254C24.1997 58.9433 22.2708 57.1333 20.75 55.0004C19.0133 52.6234 17.8179 49.8951 17.2476 47.007C16.6773 44.1189 16.746 41.1411 17.4488 38.2823C18.1515 35.4236 19.4714 32.7533 21.3157 30.4588C23.1601 28.1643 25.4842 26.3013 28.125 25.0004C28.925 24.6254 30.25 23.9754 32.025 24.0004C33.274 24.0101 34.5039 24.3084 35.6185 24.8722C36.733 25.436 37.7021 26.25 38.45 27.2504C39.4559 28.6031 40.0073 30.2398 40.025 31.9254C40.025 31.8754 46.15 12.0254 20.025 12.0254C9.04999 12.0254 0.0249941 22.4254 0.0249941 31.5754C-0.0186596 36.4088 1.01469 41.1912 3.04999 45.5754C6.38318 52.673 12.2063 58.2997 19.4141 61.3874C26.6218 64.4751 34.7124 64.8089 42.15 62.3254C39.5443 63.1484 36.7909 63.3957 34.0803 63.0504C31.3696 62.7051 28.7662 61.7754 26.45 60.3254H26.425Z",
    fill: "url(#paint2_linear_3511_38129)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M26.425 60.3254C24.1997 58.9433 22.2708 57.1333 20.75 55.0004C19.0133 52.6234 17.8179 49.8951 17.2476 47.007C16.6773 44.1189 16.746 41.1411 17.4488 38.2823C18.1515 35.4236 19.4714 32.7533 21.3157 30.4588C23.1601 28.1643 25.4842 26.3013 28.125 25.0004C28.925 24.6254 30.25 23.9754 32.025 24.0004C33.274 24.0101 34.5039 24.3084 35.6185 24.8722C36.733 25.436 37.7021 26.25 38.45 27.2504C39.4559 28.6031 40.0073 30.2398 40.025 31.9254C40.025 31.8754 46.15 12.0254 20.025 12.0254C9.04999 12.0254 0.0249941 22.4254 0.0249941 31.5754C-0.0186596 36.4088 1.01469 41.1912 3.04999 45.5754C6.38318 52.673 12.2063 58.2997 19.4141 61.3874C26.6218 64.4751 34.7124 64.8089 42.15 62.3254C39.5443 63.1484 36.7909 63.3957 34.0803 63.0504C31.3696 62.7051 28.7662 61.7754 26.45 60.3254H26.425Z",
    fill: "url(#paint3_radial_3511_38129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1 37.2C37.875 37.45 37.25 37.825 37.25 38.6C37.25 39.25 37.675 39.9 38.45 40.425C42.025 42.925 48.8 42.575 48.825 42.575C51.4901 42.5732 54.106 41.8567 56.4 40.5C58.7095 39.1492 60.6258 37.2181 61.9589 34.8983C63.292 32.5785 63.9957 29.9506 64 27.275C64.075 21.675 62 17.95 61.175 16.3C55.85 5.95 44.425 1.56661e-07 32 1.56661e-07C23.5905 -0.000831393 15.5186 3.30875 9.53021 9.21293C3.54181 15.1171 0.118259 23.1413 0 31.55C0.125 22.425 9.2 15.05 20 15.05C20.875 15.05 25.875 15.125 30.5 17.55C33.7493 19.1646 36.44 21.7161 38.225 24.875C39.75 27.525 40.025 30.9 40.025 32.25C40.025 33.6 39.35 35.575 38.075 37.225L38.1 37.2Z",
    fill: "url(#paint4_radial_3511_38129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1 37.2C37.875 37.45 37.25 37.825 37.25 38.6C37.25 39.25 37.675 39.9 38.45 40.425C42.025 42.925 48.8 42.575 48.825 42.575C51.4901 42.5732 54.106 41.8567 56.4 40.5C58.7095 39.1492 60.6258 37.2181 61.9589 34.8983C63.292 32.5785 63.9957 29.9506 64 27.275C64.075 21.675 62 17.95 61.175 16.3C55.85 5.95 44.425 1.56661e-07 32 1.56661e-07C23.5905 -0.000831393 15.5186 3.30875 9.53021 9.21293C3.54181 15.1171 0.118259 23.1413 0 31.55C0.125 22.425 9.2 15.05 20 15.05C20.875 15.05 25.875 15.125 30.5 17.55C33.7493 19.1646 36.44 21.7161 38.225 24.875C39.75 27.525 40.025 30.9 40.025 32.25C40.025 33.6 39.35 35.575 38.075 37.225L38.1 37.2Z",
    fill: "url(#paint5_radial_3511_38129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3511_38129",
    x1: 14.675,
    y1: 44.25,
    x2: 59.275,
    y2: 44.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3511_38129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3 44.5863) scale(23.85 22.6575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3511_38129",
    x1: 38.175,
    y1: 24.9004,
    x2: 10.35,
    y2: 55.2254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3511_38129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6387 49.7346) rotate(-81.3844) scale(35.8465 28.9604)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3511_38129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.4725 11.829) rotate(92.2906) scale(50.6405 107.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3511_38129",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.015 19.325) rotate(73.7398) scale(24.325 19.7811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3511_38129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdgeLogo);
export default __webpack_public_path__ + "static/media/Microsoft_Edge_logo.417452e4a5889e3fee91bcf16bf132ad.svg";
export { ForwardRef as ReactComponent };